import { render, staticRenderFns } from "./EventReportListEntryFieldReadonly.vue?vue&type=template&id=3fc2b06e&scoped=true"
import script from "./EventReportListEntryFieldReadonly.vue?vue&type=script&lang=ts"
export * from "./EventReportListEntryFieldReadonly.vue?vue&type=script&lang=ts"
import style0 from "./EventReportListEntryFieldReadonly.vue?vue&type=style&index=0&id=3fc2b06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc2b06e",
  null
  
)

export default component.exports